<template>
<div class="row auction">

	<div class="col">

		<div class="row">
			<div class="col">
				<b-jumbotron class="mb-3"
				             :header="activeAuction.title"
				             :lead="activeAuction.description"></b-jumbotron>
			</div>
		</div>

		<div class="row justify-content-center">

			<div class="col-sm-6 col-lg-3 mb-3">
				<dashboard-icon-button
					toName="liveAuction"
					buttonTitle="Start veiling"
					iconName="gavel"
				/>
			</div>

			<div class="col-sm-6 col-lg-3 mb-3">
				<dashboard-icon-button
					toName="itemAdd"
					buttonTitle="Kavel"
					iconName="plus"
				/>
			</div>

			<div class="col-sm-6 col-lg-3 mb-3" v-if="financialPermission">
				<dashboard-icon-button
					buttonTitle="Financieël overzicht"
					iconName="download"
					:loading="isDownloading"
					@click="downloadOverview"
				/>
			</div>
		</div>

	</div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { setTitle } from '@/helpers/page-helper';
import { find } from 'lodash';
import AuctionService from '@/services/auction-service.js';
import DashboardIconButton from '@/components/elements/DashboardIconButton'

export default {
	components: {
		DashboardIconButton,
	},
	data() {
		return {
			message: 'Dashboard',
			financialPermission: false,
			isDownloading: false,
		}
	},
	methods: {
		async downloadOverview() {
			this.isDownloading = true;
			
			try {
				const response = await AuctionService.getAuctionOverview(this.$route.params.auctionId);
				
				const data = window.URL.createObjectURL(response);
				const dateString = `${(new Date()).toLocaleDateString('nl', { year:'numeric', month:'numeric', day:'numeric' })}`
				let aTag = document.createElement('a');
				
				aTag.href = data;
				aTag.download = `Financieel overzicht ${dateString}.pdf`;
				aTag.style = "position: absolute; opacity: 0;";
				aTag.target = '_blank';
				
				document.body.appendChild(aTag);
				aTag.click();

				this.isDownloading = false;
				
				setTimeout(function () {
					document.body.removeChild(aTag);
					window.URL.revokeObjectURL(data);
				}, 100);

			}
			catch (error) {
				this.isDownloading = false;

				throw error;	
			}
		},
		setMe() {
			this.financialPermission = find(this.me.permissions, function(permission) {
				return permission.name == 'financial';
			});
		}
	},
	computed: {
		...mapGetters([
			'activeAuction',
			'me'
		])
	},
	watch: {
		'me': 'setMe'
	},
	mounted() {
		setTitle(this.activeAuction.title);
		this.setMe();
	}
}
</script>



// WEBPACK FOOTER //
// Auction.vue?32d6f277